export default {
  getSipConfig: state => state.sipConfig,
}
